import { gql } from "@apollo/client";

export const GET_ALL_TEAM_MEMBERS_QUERY = gql`
  query ($orgId: String!) {
    getAllTeamMembers(orgId: $orgId) {
      id
      organizationId
      userId
      firstName
      lastName
      email
      role
      isAccepted
      relationshipToOrganization
    }
  }
`;
